export interface Category {
  slug: string;
  name: string;
  description: string;
  color: string;
  ogImage: string;
}

export const categories: Category[] = [
  {
    slug: 'dating',
    name: 'Dating',
    description: 'Tips, advice, and stories about modern dating',
    color: '#e85d75',
    ogImage: 'https://public.readdy.ai/ai/img_res/e0179279bff3a1f5e333d76b9be99175.jpg',
  },
  {
    slug: 'communication',
    name: 'Communication',
    description: 'How to talk, listen, and connect deeply',
    color: '#f4a261',
    ogImage: 'https://readdy.ai/api/search-image?query=couple%20sitting%20face%20to%20face%20in%20a%20bright%20airy%20living%20room%20having%20a%20deep%20heartfelt%20conversation%20attentive%20listening%20warm%20natural%20daylight%20soft%20focus%20editorial%20photography&width=1200&height=630&seq=cat-communication-og&orientation=landscape',
  },
  {
    slug: 'breakups',
    name: 'Breakups & Healing',
    description: 'Moving on, healing, and finding yourself again',
    color: '#9b72cf',
    ogImage: 'https://readdy.ai/api/search-image?query=woman%20sitting%20alone%20by%20a%20large%20window%20looking%20outside%20with%20a%20contemplative%20peaceful%20expression%20soft%20natural%20light%20streaming%20in%20emotional%20healing%20solitude%20introspective%20mood%20editorial%20photography&width=1200&height=630&seq=cat-breakups-og&orientation=landscape',
  },
  {
    slug: 'marriage',
    name: 'Marriage & Commitment',
    description: 'Building a lasting, loving partnership',
    color: '#2a9d8f',
    ogImage: 'https://readdy.ai/api/search-image?query=happy%20married%20couple%20laughing%20together%20outdoors%20in%20golden%20hour%20sunlight%20holding%20hands%20joyful%20genuine%20connection%20warm%20tones%20editorial%20lifestyle%20photography%20beautiful%20natural%20setting&width=1200&height=630&seq=cat-marriage-og&orientation=landscape',
  },
  {
    slug: 'self-love',
    name: 'Self-Love',
    description: 'Loving yourself first so you can love others better',
    color: '#e9c46a',
    ogImage: 'https://readdy.ai/api/search-image?query=confident%20woman%20smiling%20radiantly%20in%20warm%20golden%20sunlight%20outdoors%20arms%20open%20free%20empowered%20self-assured%20joyful%20expression%20soft%20bokeh%20background%20editorial%20lifestyle%20photography&width=1200&height=630&seq=cat-selflove-og&orientation=landscape',
  },
];
